const FancyIntensity = [
    "BROWN",
    "BROWNISH",
    "DARK",
    "DEEP",
    "FAINT",
    "GREY",
    "GREYISH",
    "INTENSE",
    "LIGHT",
    "LIGHT BROWNISH",
    "ORANGE",
    "PINK",
    "VERY LIGHT",
    "VIVID",
    "VIVID GREY",
    "YELLOW"
];

export default FancyIntensity;

